import { useState, useEffect } from 'react'
import {
  TextField,
  InputAdornment,
  List,
  Card,
  FormControl,
  ListItem,
} from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import axios from 'axios'
import SearchIcon from '@mui/icons-material/Search'
import PropTypes from 'prop-types'
import moment from 'moment'

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    width: '100%',
  },
  listContainer: {
    position: 'absolute',
    zIndex: 2,
    top: '100%',
    left: 0,
    width: '100%',
    backgroundColor: theme.palette.white.light,
  },
}))

const Search = ({
  emitValue,
  disabled,
  error,
  label = 'Pacjent',
  helperText,
  wholeObject = false,
}) => {
  const classes = useStyles()

  const [value, setValue] = useState('')
  const [results, setResults] = useState([])
  const [show, _setShow] = useState(false)
  const [timeoutValue, setTimeoutValue] = useState(null)

  const setShow = (value) => {
    setTimeout(() => {
      _setShow(value)
    }, 300)
  }

  const search = () => {
    axios.post('/patients/search', { value }).then((res) => {
      setResults(res.data)
    })
  }

  useEffect(() => {
    // const changeValue = (value) => {
    setValue(value)
    if (value.length >= 2) {
      // console.log(timeoutValue)
      // console.log('value_length:', value.length)
      // console.log('value:', value)
      if (timeoutValue) {
        clearTimeout(timeoutValue)
      }
      setTimeoutValue(setTimeout(search, 300))
    } else {
      setResults([])
    }
    // }
  }, [value])
  return (
    <>
      <FormControl fullWidth className={classes.root}>
        <TextField
          error={error}
          helperText={helperText}
          disabled={disabled}
          label={label}
          placeholder="Szukaj"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          onFocus={() => setShow(true)}
          onBlur={() => setShow(false)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon fontSize="small" />
              </InputAdornment>
            ),
          }}
        />
        {show && results && results.length > 0 && (
          <Card className={classes.listContainer} elevation={4}>
            <List>
              {results.map((result) => (
                <ListItem
                  key={result.id}
                  button
                  onClick={() => {
                    emitValue(
                      wholeObject ? result : result.id,
                      `${result.firstname} ${result.lastname}`
                    )
                    setValue('')
                    setResults([])
                  }}
                >
                  {result.firstname} {` `}
                  {result.lastname} {` - `} {`(`}
                  {moment(result.birth_date).format('YYYY-MM-DD')}
                  {`)`}
                  {result.pesel && ` - ${result.pesel}`}
                </ListItem>
              ))}
            </List>
          </Card>
        )}
      </FormControl>
    </>
  )
}

Search.propTypes = {
  emitValue: PropTypes.func,
  wholeObject: PropTypes.bool,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  label: PropTypes.string,
}

export default Search
